import {
  // PUBLIC,
  // REMEMBERED,
  LOGGED_IN,
  ELEVATED,
  SUPERUSER,
} from 'auth';

import { Url } from 'lib/utils/url';

import {
  // types
  URI,
  CUSTOMER_LOAD,
  RE_AUTHENTICATE,
  AUTHORISATION_PROBLEM,
  STORE_PICK,

  // required type fields
  LOCATION,
  REASON,
  CURRENT_AUTHENTICATION_LEVEL,
  REQUIRED_AUTHENTICATION_LEVEL,
  AUTHORISATION_VIOLATION,

  // reasons
  SSO_SESSION_SYNC_NEEDED,
  ANOTHER_SESSION_EXISTS,
  REDIRECTING_TO_ANOTHER_SERVER,
  FAILED_PAYMENTS,
  LOAD_CUSTOMER_OVERFLOW,
  UNABLE_TO_LOGIN_CUSTOMER_VIA_REMEMBER_ME,
} from '../redirectTypes';

import authorisationProblemRedirects from 'apps/user/models/authorisationProblemRedirects';
import { config } from 'api';

export const SHOW_REDIRECT_WARNING = 'SHOW_REDIRECT_WARNING';
export const HIDE_REDIRECT_WARNING = 'HIDE_REDIRECT_WARNING';
export const REDIRECT_WITHOUT_WARNING = 'REDIRECT_WITHOUT_WARNING';
export const REMOVE_REDIRECT = 'REMOVE_REDIRECT';

export function redirectWithoutWarning(opts) {
  return {
    type: REDIRECT_WITHOUT_WARNING,
    redirect: {
      type: opts.type,
      to: opts.to,
      reload: opts.reload || false,
    },
  };
}

export function showCustomerLoadWarning(data, opts) {
  return {
    type: SHOW_REDIRECT_WARNING,
    redirect: {
      type: CUSTOMER_LOAD,
      fields: {
        reason: data[REASON],
      },
      to: opts.to,
      reload: opts.reload || false,
    },
  };
}

export function showTooLowAuthLevelWarning(data, opts) {
  return {
    type: SHOW_REDIRECT_WARNING,
    redirect: {
      type: RE_AUTHENTICATE,
      fields: {
        currentAuthenticationLevel: data[CURRENT_AUTHENTICATION_LEVEL],
        requiredAuthenticationLevel: data[REQUIRED_AUTHENTICATION_LEVEL],
      },
      to: opts.to,
      reload: opts.reload || false,
    },
  };
}

export function hideRedirectWarning() {
  return {
    type: HIDE_REDIRECT_WARNING,
  };
}

export function removeRedirect() {
  return {
    type: REMOVE_REDIRECT,
  };
}

function customerLoadHandler(data, currentUrl) {
  const reason = data[REASON];

  switch (reason) {
    case SSO_SESSION_SYNC_NEEDED:
      return redirectWithoutWarning({
        type: CUSTOMER_LOAD,
        to: new Url('/webshop/sso/synchronize.go')
          .addQueryParameters({ postSynchronizationUri: currentUrl })
          .toString(),
        reload: true,
      });
    case ANOTHER_SESSION_EXISTS:
      return redirectWithoutWarning({
        type: CUSTOMER_LOAD,
        to: '/login',
        reload: true,
      });
    case REDIRECTING_TO_ANOTHER_SERVER:
      return redirectWithoutWarning({
        type: CUSTOMER_LOAD,
        to: '/',
        reload: true,
      });
    case FAILED_PAYMENTS:
      return showCustomerLoadWarning(data, {
        to: '/webshop/getFailedPaymentOrders.go',
      });
    case LOAD_CUSTOMER_OVERFLOW:
      return redirectWithoutWarning({
        type: CUSTOMER_LOAD,
        to: '/webshop/busy.do',
        reload: true,
      });
    case UNABLE_TO_LOGIN_CUSTOMER_VIA_REMEMBER_ME:
      return redirectWithoutWarning({
        type: CUSTOMER_LOAD,
        to: '/webshop/error.do',
        reload: true,
      });
    default:
      return showCustomerLoadWarning(data);
  }
}

function authorisationProblemHandler(data) {
  const violation = data[AUTHORISATION_VIOLATION];
  const to = authorisationProblemRedirects[violation];

  return redirectWithoutWarning({
    type: AUTHORISATION_PROBLEM,
    reload: true,
    to,
  });
}

export function actionByType({ type, data, currentUrl, callback, loginElevatedInRavenEnabled }) {
  switch (type) {
    case URI: {
      return redirectWithoutWarning({
        to: data[LOCATION],
      });
    }
    case CUSTOMER_LOAD: {
      return customerLoadHandler(data, currentUrl);
    }
    case RE_AUTHENTICATE: {
      if (data[REQUIRED_AUTHENTICATION_LEVEL] === ELEVATED || data[REQUIRED_AUTHENTICATION_LEVEL] === LOGGED_IN) {
        const loginElevatedUrl = loginElevatedInRavenEnabled ?
          new Url('/login-elevated').addQueryParameter('redirect', currentUrl).toString() :
          new Url('/webshop/loginElevated.go').addQueryParameter('success_redirect', currentUrl).toString();

        return redirectWithoutWarning({
          type: CUSTOMER_LOAD,
          to: loginElevatedUrl,
          reload: true,
        });
      } else if (data[REQUIRED_AUTHENTICATION_LEVEL] === SUPERUSER) {
        return redirectWithoutWarning({
          type: RE_AUTHENTICATE,
          to: '/not-found',
          reload: false,
        });
      } else {
        return redirectWithoutWarning({
          type: RE_AUTHENTICATE,
          to: '/login',
          reload: true,
        });
      }
    }
    case AUTHORISATION_PROBLEM:
      return authorisationProblemHandler(data);
    case STORE_PICK:
      callback();
      return redirectWithoutWarning({
        type: STORE_PICK,
        to: config.ospUrl,
      });
    default:
  }
  return false;
}

export function apiRedirect(redirectOpts) {
  return (dispatch, getState, { network }) => {
    dispatch(removeRedirect());
    network.redirectTo(redirectOpts);
  };
}
